import React from 'react';
import BusinessInfo from '../../../../../shared/components/BusinessInfo';

const BusinessProfile = () => {
    return (
        <div className="content-background">
            <BusinessInfo />
        </div>
    );
};

export default BusinessProfile;
